import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import When from 'components/When';
import { bem } from 'helpers/class-name';

import saveErrorMessages from './ItemSaveErrorBanner.messages';
import SkuModifierGroupPicker from './SkuModifierGroupPicker';

const { element } = bem('item-form');

const SkuItemModifiersSlot = ({
  groups,
  value,
  onChange,
  onAddModifierGroup,
  isLoading,
  loadFailed,
  onRetry,
  failed,
  readOnly,
}) => (
  <>
    <div className={element('modifiers-section', { failed })}>
      <SkuModifierGroupPicker
        groups={groups}
        value={value}
        onChange={onChange}
        onAddModifierGroup={onAddModifierGroup}
        isLoading={isLoading}
        loadFailed={loadFailed}
        onRetry={onRetry}
        readOnly={readOnly}
      />
    </div>
    <When predicate={failed}>
      <Message as="p" message={saveErrorMessages.modifiersInline} className={element('save-error-inline')} />
    </When>
  </>
);

SkuItemModifiersSlot.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  onAddModifierGroup: PropTypes.func,
  isLoading: PropTypes.bool,
  loadFailed: PropTypes.bool,
  onRetry: PropTypes.func,
  failed: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default SkuItemModifiersSlot;
